import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CarouselSection />
        <UpdatesSection />
        <FaqSection />
        <CardsSection />
        <TopicsSection />
        <FeaturesSection />
        <MediaSection />
        <IndexSection />
        <RankingSection />
        <AboutSection />
        <ContactSection />
        <CommentsSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}